/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ThankYouScreenResetPathParams, ThankYouScreenResetResponse } from '../types/ThankYouScreenReset'

/**
 * POST /thank-you-screens/:thankYouScreen/reset
 * @see backend/nexus/modules/Form/Http/Controllers/ThankYouScreenController.php ThankYouScreenController::reset
 */
export async function thankYouScreenReset(
	thankYouScreen: ThankYouScreenResetPathParams['thankYouScreen'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ThankYouScreenResetResponse>> {
	return axiosInstance.post(`/thank-you-screens/${thankYouScreen}/reset`, undefined, config)
}
